import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Container,
  Row,
  CardBody,
} from "reactstrap";
// core components
import Header from "components/Headers/UserHeader";
import EmployeeDataService from "../../services/EmployeeDataService";

class EmployeeUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
    };
    this.EmployeeDataService = new EmployeeDataService();
  }

  handleInputChanged(e) {
    this.setState({ file_csv: e.target.files[0]})
  }

  handleUpload() {
      this.EmployeeDataService.upload(this.state.file_csv)
        .then(() => { this.setState({ success: true })})
  }

  render() {    
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  
                </CardHeader>
                <CardBody>
                <Form role="form">
                    <FormGroup>
                        <Row>
                            <Col lg="12">
                                {this.state.success && (
                                    <Alert color="success">
                                        Upload csv karyawan berhasil.
                                    </Alert>
                                )}
                            </Col>
                            <Col lg="6">
                                <label
                                    className="form-control-label"
                                    htmlFor="input-barcode"
                                >
                                    Upload csv karyawan
                                </label>
                                <InputGroup className="input-group-alternative">
                                    <Input
                                    name="file_csv"
                                    onChange={this.handleInputChanged.bind(this)}
                                    type="file" />
                                </InputGroup>  
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <div className="btn-wrapper text-right">
                        <Button
                            className="my-4"
                            color="primary"
                            type="button"
                            onClick={() => this.handleUpload()}
                            >
                            Upload
                        </Button>
                        </div> 
                    </FormGroup> 
                </Form>
                </CardBody>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default EmployeeUpload;
